//libs
import React, { useEffect, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

//components
import ViewSimilarDesktop from 'shared/components/ViewSimilar/Desktop/components/ViewSimilarOverlay/ViewSimilarDesktop';
import { Spinner } from '@nykaa/ui-components/Loader';

// hook
import useWidgetLoader from 'shared/layouts/DetailsPage/components/WidgetLoader/useWidgetLoader';

// selectors
import { isWidgetFetching } from 'shared/store/widgets/selectors';

// actions
import { fetchWidgetData } from 'shared/store/widgets/services';

//helpers
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

export interface OverLaySheetProps {
  productID: string;
  hasUpdatedI18n?: boolean;
  isXHRAllowed?: boolean;
  currency?: string;
  countryCode?: string;
  isMobile?: boolean;
  closeSheet: VoidFunction;
  selectedProduct?: Listing.IProduct;
}

function OverlayWrapper({
  closeSheet,
  productID,
  isMobile = false,
  selectedProduct,
}: OverLaySheetProps) {
  const { transformedWidgetData: apiConfig } = useWidgetLoader({ isMobile });
  const isFetching = useSelector(isWidgetFetching);
  const dispatch = useDispatch();
  const isViewSimilarEnabled = useRemoteConfig('viewSimilarPLP').desktop;

  useEffect(() => {
    dispatch(fetchWidgetData({ productID, apiConfig }));
  }, [productID, apiConfig, dispatch]);

  if (!isViewSimilarEnabled) return null;
  return (
    <ViewSimilarDesktop
      closeSheet={closeSheet}
      selectedProduct={selectedProduct}
      isFetching={isFetching}
      fallback={<Spinner />}
    />
  );
}

export default memo(OverlayWrapper);
